import {
  SAMLAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  updateProfile,
  signOut
} from "firebase/auth";
import { Auth } from "./firebase";
import { createTempUser } from "./index";

export const Provider = source => {
  return new Promise((resolve, reject) => {
    const provider = new SAMLAuthProvider(source);
    //provider.addScope("profile");
    //provider.addScope("email");

    signInWithPopup(Auth, provider)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const SignIn = (email, password) => {
  return new Promise((resolve, reject) => {
    signInWithEmailAndPassword(Auth, email, password)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const sendVerificationEmail = user => {
  const redirect =
    !process.env.NODE_ENV || process.env.NODE_ENV === "development"
      ? "http://localhost:3000/"
      : `${process.env.REACT_APP_PUBLIC_URL}/`;
  return sendEmailVerification(user, { url: redirect });
};

export const RegisterUser = (email, password, displayName) => {
  return new Promise((resolve, reject) => {
    createUserWithEmailAndPassword(Auth, email, password)
      .then(result => {
        updateProfile(result.user, { displayName }).then(
          () => {
            createTempUser({ displayName, uid: result.user.uid }).then(
              () => {
                // Wait for the verification email request to finish BEFORE
                // signing out, otherwise signOut tears down the auth session
                // while the sendEmailVerification request is still in flight.
                sendVerificationEmail(result.user).then(
                  () => {
                    signOut(Auth);
                    resolve();
                  },
                  error => {
                    console.error("sendEmailVerification failed", error);
                    signOut(Auth);
                    resolve();
                  }
                );
              },
              err => {
                reject(err);
              }
            );
          },
          err => {
            reject(err);
          }
        );
      })
      .catch(error => {
        reject(error);
      });
  });
};
